<dx-popup
  [(visible)]="visible"
  [showTitle]="false"
  [showCloseButton]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.3)"
  (onShowing)="onShowingHandler()"
  (onHiding)="onHidingHandler()"
  [width]="width()"
  [height]="height()"
  [maxHeight]="maxHeight()"
  [dragEnabled]="false"
  [hideOnOutsideClick]="allowOutsideClick()"
  [deferRendering]="deferRendering()"
  [wrapperAttr]="{ class: 'gpd-popup gpd-popup-fill' }"
>
  <div class="gpd-popup-inner">
    <div class="gpd-popup-header">
      <div class="gpd-popup-title-group">
        <app-svg-icon
          *ngIf="titleIcon()"
          [icon]="titleIcon()"
          [size]="20"
          color="#f5a623"
          class="gpd-popup-title-icon"
        ></app-svg-icon>
        <span class="gpd-popup-title">{{ title() }}</span>
      </div>
      <app-gpd-button type="text" icon="cancel" (onClick)="onCloseBtnClicked($event)"></app-gpd-button>
    </div>

    <div class="msp-step" *ngIf="steps()?.length > 0">
      <div class="msp-content-section">
        <div class="stepper-container">
          <gpd-stepper
            [items]="stepperItems()"
            [(selectedIndex)]="currentStepIndex"
            (selectionChanged)="onStepperSelectionChanged($event)"
          ></gpd-stepper>
        </div>
        <dx-multi-view
          [(selectedIndex)]="currentStepIndex"
          width="100%"
          height="100%"
          [draggable]="false"
          [swipeEnabled]="false"
          class="msp-multi-view"
        >
          <dxi-multi-view-item *ngFor="let step of steps()">
            <div *dxTemplate class="msp-step-pane">
              <dx-validation-group [id]="'validation-group-' + step.id">
                <div class="msp-form-section">
                  <div class="step-description" *ngIf="step.description">
                    {{ step.description }}
                  </div>
                  <div class="step-content">
                    <ng-container
                      *ngTemplateOutlet="
                        step.template;
                        context: {
                          validationGroup: 'validation-group-' + step.id,
                        }
                      "
                    ></ng-container>
                  </div>
                </div>
              </dx-validation-group>
            </div>
          </dxi-multi-view-item>
        </dx-multi-view>
      </div>
      <div class="msp-actions-section">
        <div class="gpd-button-group">
          <app-gpd-button
            *ngIf="currentStepIndex() > 0"
            i18n-text="@@back"
            text="Back"
            type="secondary"
            (onClick)="onPreviousBtnClicked($event)"
          ></app-gpd-button>
          <app-gpd-button
            *ngIf="currentStepIndex() < steps().length - 1"
            i18n-text="@@next"
            text="Next"
            [disabled]="isNextButtonDisabled()"
            (onClick)="onNextBtnClicked($event)"
          ></app-gpd-button>
          <app-gpd-button
            *ngIf="currentStepIndex() === steps().length - 1"
            [text]="finishText()"
            type="primary"
            [disabled]="isNextButtonDisabled() || isFinishButtonDisabled()"
            (onClick)="onFinishBtnClicked($event)"
          ></app-gpd-button>
        </div>
      </div>
    </div>
  </div>
</dx-popup>
